export enum ActionPageKey {
    Registration = 'registration',
    Sponsor = 'sponsor',
    Papers = 'papers',
}
